import { render, staticRenderFns } from "./Only-Video.vue?vue&type=template&id=e7aebe78&scoped=true"
import script from "./Only-Video.vue?vue&type=script&lang=js"
export * from "./Only-Video.vue?vue&type=script&lang=js"
import style0 from "./Only-Video.vue?vue&type=style&index=0&id=e7aebe78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7aebe78",
  null
  
)

export default component.exports